/* eslint-disable no-shadow */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import {
  faTimes,
  faEnvelope,
  faPhone,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { submitUpdate } from "../../../actions/agencyProfileActions";
import Warning from "./Warning";
import {
  Wrapper,
  CloseButton,
  Form,
  TextInput,
  DisabledInput,
  DisabledInputWrapper,
  SaveButton,
  ToggleSection,
  EditContact,
} from "./styles/user-edit-styles";

class UserEdit extends Component {
  constructor(props) {
    super(props);
    const { user } = this.props;
    const {
      companyName,
      email,
      firstName,
      id,
      lastName,
      linkedin,
      location,
      phone,
      website,
      yearsExperience,
      isAdmin,
      existingSince,
    } = user;

    this.state = {
      id,
      firstName,
      lastName,
      companyName,
      location,
      yearsExperience,
      email,
      phone,
      website,
      linkedin,
      editContactActive: false,
      warningActive: false,
      isAdmin,
      existingSince,
    };
  }

  toggleWarning = () => {
    this.setState(({ warningActive }) => ({ warningActive: !warningActive }));
  };

  toggleContactEdit = () => {
    this.setState(({ editContactActive }) => ({
      editContactActive: !editContactActive,
    }));
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { submitUpdate, toggleEditUserInfo } = this.props;
    const {
      id,
      firstName,
      lastName,
      companyName,
      location,
      yearsExperience,
      phone,
      linkedin,
      website,
      existingSince,
    } = this.state;

    const newData = {
      user: {
        id,
        firstName,
        lastName,
        location,
        yearsExperience: Number(yearsExperience),
        mobileNumber: phone,
        linkedinUrl: linkedin,
        recruiter: {
          name: companyName,
          websiteAddress: website,
        },
        existingSince,
      },
    };

    submitUpdate(newData, toggleEditUserInfo, "USER");
  };

  render() {
    const { toggleEditUserInfo } = this.props;
    const {
      firstName,
      lastName,
      companyName,
      location,
      yearsExperience,
      email,
      phone,
      linkedin,
      website,
      warningActive,
      editContactActive,
      isAdmin,
      existingSince,
    } = this.state;

    return (
      <Wrapper>
        {editContactActive && (
          <EditContact>
            <Form>
              <DisabledInputWrapper>
                <FontAwesomeIcon icon={faEnvelope} />
                <DisabledInput>{email}</DisabledInput>
              </DisabledInputWrapper>
              <FontAwesomeIcon icon={faPhone} />
              <TextInput
                contact
                type="text"
                placeholder="Phone"
                value={phone}
                name="phone"
                onChange={this.handleChange}
              />
              <FontAwesomeIcon icon={faLinkedin} />
              <ReactTooltip
                html
                place="bottom"
                type="dark"
                effect="solid"
                aria-haspopup="true"
                id="linkedin-url"
              />
              <TextInput
                contact
                id="linkedin-url"
                type="text"
                placeholder="LinkedIn"
                value={linkedin}
                name="linkedin"
                onChange={this.handleChange}
                data-for="linkedin-url"
                data-tip="Must start with 'https://'"
              />
              <FontAwesomeIcon icon={faGlobe} />
              <ReactTooltip
                html
                place="bottom"
                type="dark"
                effect="solid"
                aria-haspopup="true"
                id="website-url"
              />
              <TextInput
                contact
                type="text"
                placeholder="Website Address"
                value={website}
                name="website"
                onChange={this.handleChange}
                data-for="website-url"
                data-tip="Must start with 'https://'"
              />
            </Form>
          </EditContact>
        )}
        {warningActive && (
          <Warning
            toggleWarning={this.toggleWarning}
            closeForm={toggleEditUserInfo}
            field="user"
          />
        )}
        <CloseButton onClick={() => this.toggleWarning()}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        <Form>
          <TextInput
            type="text"
            placeholder="First name"
            firstName
            value={firstName}
            name="firstName"
            onChange={this.handleChange}
          />
          <TextInput
            type="text"
            placeholder="Last name"
            lastName
            value={lastName}
            name="lastName"
            onChange={this.handleChange}
          />
          {isAdmin ? (
            <TextInput
              type="text"
              placeholder="Company name"
              value={companyName}
              name="companyName"
              onChange={this.handleChange}
            />
          ) : (
            <DisabledInput>{companyName}</DisabledInput>
          )}
          <TextInput
            type="text"
            placeholder="Location"
            value={location}
            name="location"
            onChange={this.handleChange}
          />
          <TextInput
            type="number"
            placeholder="Experience"
            yearsExperience
            value={yearsExperience}
            name="yearsExperience"
            onChange={this.handleChange}
          />
          <span>years</span>
          <TextInput
            type="date"
            placeholder="Existing Since"
            value={existingSince}
            name="existingSince"
            onChange={this.handleChange}
          />
          <ToggleSection onClick={this.toggleContactEdit}>
            {editContactActive ? "edit info" : "edit contact"}
          </ToggleSection>
          <SaveButton onClick={this.handleSubmit}>save</SaveButton>
        </Form>
      </Wrapper>
    );
  }
}

UserEdit.propTypes = {
  toggleEditUserInfo: PropTypes.func.isRequired,
  submitUpdate: PropTypes.func.isRequired,
  user: PropTypes.shape({
    companyName: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    id: PropTypes.string,
    lastName: PropTypes.string,
    linkedin: PropTypes.string,
    location: PropTypes.string,
    phone: PropTypes.string,
    website: PropTypes.string,
    yearsExperience: PropTypes.number,
    isAdmin: PropTypes.bool,
    existingSince: PropTypes.date,
  }),
};

UserEdit.defaultProps = {
  user: PropTypes.shape({
    companyName: PropTypes.isNull,
    email: PropTypes.isNull,
    firstName: PropTypes.isNull,
    id: PropTypes.isNull,
    lastName: PropTypes.isNull,
    linkedin: PropTypes.isNull,
    location: PropTypes.isNull,
    phone: PropTypes.isNull,
    website: PropTypes.isNull,
    yearsExperience: PropTypes.isNull,
    isAdmin: PropTypes.isNull,
    existingSince: PropTypes.isNull,
  }),
};

const mapStateToProps = (state) => ({
  user: state.agencyProfile.profileData.user,
});

export default connect(mapStateToProps, { submitUpdate })(UserEdit);
